import styled from "styled-components"

export const AddressComparison = styled.div`
  margin: 1.5rem 0;
  padding: 1.5rem;
  background: ${(p) => p.theme.colors.background};
  border-radius: 0.5rem;
  border: 1px solid ${(p) => p.theme.colors.borderLight};
`

export const AddressSection = styled.div`
  margin-bottom: 1.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const AddressSectionTitle = styled.h4`
  margin: 0 0 0.8rem 0;
  font-size: 1.1rem;
  color: ${(p) => p.theme.colors.greyDark};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`

export const AddressGridHeader = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  gap: 0.5rem 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid ${(p) => p.theme.colors.borderLight};
  margin-bottom: 0.5rem;
  font-weight: 700;
  font-size: 1rem;
  color: ${(p) => p.theme.colors.greyDark};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`

export const AddressRow = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  gap: 0.5rem 1rem;
  padding: 0.3rem 0;
  font-size: 1.1rem;
`

export const FieldLabel = styled.span`
  color: ${(p) => p.theme.colors.greyDark};
  font-weight: 600;
`

export const FieldValue = styled.span`
  color: ${(p) => p.theme.colors.black};
`
